import React from 'react';
import { useT } from '@repo/common';

const QnaSearchError = () => {
  const t = useT();
  const searchErrorImageUrl = `${process.env.REACT_APP_ASSETS_URL}/img-search-error.svg`;
  return (
    <div className='w-full flex justify-center pt-[120px] pb-[260px] tabletH:pt-10 tabletH:pb-30'>
      <div className='w-full flex flex-col items-center'>
        <div className='pb-6'>
          <img
            src={searchErrorImageUrl}
            alt='search error'
            className='w-[180px] h-auto tabletH:w-[280px]'
          />
        </div>

        <div className='flex flex-col items-center gap-1 text-text-secondary'>
          <div className='typo-h6 tabletH:typo-h3'>
            {t('Oops', '앗, 이런!')}
          </div>
          <div>
            {t(
              'There is no result for your search',
              '검색 결과가 없습니다',
            )}
          </div>
          <div>{t('Come on, try again!', '다시 한 번 검색해 보세요!')}</div>
        </div>
      </div>
    </div>
  );
};

export default QnaSearchError;
